import React from 'react';

import './HelpPage.less';

export const HelpPage = () => {
  window.document.title = `Help`;

  return (
    <div id="help-page">
      <div className="help-page-header">
        <div className='help-contact'>
          <div className='help-contact-title'>
            <b>Need Help? We&apos;re Here for You.&nbsp;</b>
            Contact our support team for assistance.
          </div>
          <div className='help-contact-title'>We’re available 8 AM – 10 PM, Monday through Sunday.</div>
          <div className='help-contact-numbers'>
            <a href="tel:+19293575037">
              <span className='title'>US:</span>
              (929) 357-5037
            </a>
            <a href="tel:+16479455457">
              <span className='title'>Canada:</span>
              (647) 945-5457
            </a>
            <a href="mailto:support@paritygo.com">
              <span className='title'>Email:</span>
              support@paritygo.com
            </a>
          </div>
          <div className='help-contact-disclaimer'>For the fastest response, call or text our support line.</div>
          <div className='help-contact-disclaimer'>For any mechanical emergencies outside of our support hours, please contact your after-hours contractor.</div>

        </div>
      </div>
    </div>
  );
};
